import React from "react";
//#region types
import { WintSuperkollAPIModelWintSalaryReport } from "wint-api-client/dist/types";
import { WintSalaryStatusTagsProps } from "models/propTypes/wintSalaryPropTypes";
//#endregion
//#region components
import { Tags } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const WintSalaryStatusTags: React.FC<WintSalaryStatusTagsProps> = (props) => {
  const { state } = props;

  const getWintSalaryStateText = (state: WintSuperkollAPIModelWintSalaryReport.WintSalaryState) => {
    return LocalizationHelperInstance.getTranslatedEnumValue("Salary.WintSalaryState", state);
  };

  const getLabelClass = (status: WintSuperkollAPIModelWintSalaryReport.WintSalaryState) => {
    switch (status) {
      case WintSuperkollAPIModelWintSalaryReport.WintSalaryState.Preliminary:
        return cssExports.grayTag;
      case WintSuperkollAPIModelWintSalaryReport.WintSalaryState.Approved:
        return cssExports.blueTag;
      case WintSuperkollAPIModelWintSalaryReport.WintSalaryState.NotApprovedInTime:
        return cssExports.redTag;
      case WintSuperkollAPIModelWintSalaryReport.WintSalaryState.AgiCreated:
        return cssExports.blueTag;
      case WintSuperkollAPIModelWintSalaryReport.WintSalaryState.AgiSigned:
        return cssExports.blueTag;
      case WintSuperkollAPIModelWintSalaryReport.WintSalaryState.Booked:
        return cssExports.greenTag;
      default:
        return cssExports.grayTag;
    }
  };

  return <Tags tags={[getWintSalaryStateText(state)]} className={getLabelClass(state)} />;
};

export default WintSalaryStatusTags;
